import { useTranslation } from 'react-i18next'
import { useRentalContractMachineContext } from '~/entities/common/RentalContract'
import {
  RentalContractCanceled,
  RentalContractContinue,
  RentalContractActive,
  RentalContractSuspend,
  RentalContractTerminate,
} from '~/widgets/common/Driver/RentalContractControls'

type ActionsProps = {
  rentalContractId: UniqueId
}

export function Actions({ rentalContractId }: ActionsProps) {
  const { canStatus } = useRentalContractMachineContext()
  const { t } = useTranslation()
  return (
    <>
      {canStatus.signing && (
        <RentalContractActive
          isButton
          rentalContractId={rentalContractId}
          title={t('sign the contract')}
          modalTitle={`${t('sign the contract')} ?`}
          modalButtonTitle={t('button.sign')}
        />
      )}
      {canStatus.active && (
        <RentalContractActive isButton rentalContractId={rentalContractId} />
      )}
      {canStatus.canceled && (
        <RentalContractCanceled isButton rentalContractId={rentalContractId} />
      )}
      {canStatus.terminate && (
        <RentalContractTerminate
          rentalContractId={rentalContractId}
          goBackOnTermination
          isButton
        />
      )}
      {canStatus.suspend && (
        <RentalContractSuspend isIcon rentalContractId={rentalContractId} />
      )}
      {canStatus.continue && (
        <RentalContractContinue isIcon rentalContractId={rentalContractId} />
      )}
    </>
  )
}
